module.exports = __webpack_public_path__ + "img/day17.6211cbb4.jpeg";